import { JobLogScheduleFlagFragment } from "src/fragments/circularFragments.generated";
import { groupBy } from "./utils";

export function combineFlagsByReasonTitle(flags: Pick<JobLogScheduleFlagFragment, "reason">[]) {
  return Object.keys(groupBy(flags, (flag) => flag.reason!.title));
}
